const Messages = {
    PhoneNumberNotPresent : 'Phone number is not present.',
    InvalidExtension : 'Invalid image Extension',
    LargeImageSize: 'File size should be smaller than 5 MB',
    SmallImageSize: 'File size should be greater than 1 KB',
    FailedUploadingDocument: 'Failed to upload document, please try again.',
    PasswordStrenthMessage: 'Password must be at least 8 characters long and must contain a number and an uppercase and a lowercase letter and a special character.'
}
export default Messages;